import Field from './base';

export default class StringList extends Field {
  renderPdf(value) {
    return value;
  }
}
